import { getFeatureTypes } from "../api/fetch.ts";
import { refreshTracks } from "../main-canvas/messages/post-track-messages.ts";
import { type components, type GenomicFeatureTypeEnum, TrackEnum } from "../openapi";
import { useGenomeViewerStore } from "../store/store.ts";
import { type NUFeatureOptions, type TrackConfig } from "./tracks/create-tracks.ts";
import { getTrackTypeFromGenomicFeatureType } from "./type-conversion.ts";

export const loadFromFeature = (
  item: components["schemas"]["FeatureLocationResponse"],
  organismId: number,
  resultType: GenomicFeatureTypeEnum,
  resultSubTypeId: number | undefined,
) => {
  const { trackGroups, tracks, createTracks } = useGenomeViewerStore.getState();

  const trackType = getTrackTypeFromGenomicFeatureType(resultType);

  const newTrackConfigs: TrackConfig[] = [];
  for (const trackGroup of [...trackGroups.values()]) {
    // 1. Check if there is already no track with the same trackType
    if (
      !trackGroup?.trackIds.some(
        (trackId) =>
          tracks.get(trackId)?.trackType === trackType || tracks.get(trackId)?.subType?.id === resultSubTypeId,
      )
    ) {
      // 2. If nuFeature check if the trackGroup has the current featureType and add it as track
      if (trackType === TrackEnum.NUCLEOTIDE_FEATURE) {
        getFeatureTypes(trackGroup.contigId).then((subTypes) => {
          const subType = subTypes.nuFeatureTypes.find((subType) => subType.id === resultSubTypeId);
          if (subType) {
            createTracks(
              [
                {
                  group: trackGroup.groupId,
                  trackType: trackType,
                  options: {
                    subType,
                  } as NUFeatureOptions,
                },
              ],
              () => {},
            );
            refreshTracks();
          }
        });
      } else {
        // 3. For classical trackTypes, add it as a track
        newTrackConfigs.push({
          group: trackGroup.groupId,
          trackType: trackType,
        });
      }
    }
  }

  if (newTrackConfigs.length > 0) {
    createTracks(newTrackConfigs, () => {});
    refreshTracks();
  }

  useGenomeViewerStore.setState({
    featureToNavigate: {
      id: item.id,
      contigId: item.contigId,
      orgId: organismId,
      type: resultType,
      start: item.range.start,
      stop: item.range.stop,
    },
  });
};
